import { BehaviorSubject } from 'rxjs';
import { filter, take } from 'rxjs/operators';
var ComponentApiController = /** @class */ (function () {
    function ComponentApiController() {
        this.initSubject = new BehaviorSubject(false);
    }
    ComponentApiController.prototype.injectApi = function (api) {
        var needInit = !this.api;
        this.api = api;
        if (needInit) {
            if (this.initSubject.isStopped) {
                this.initSubject = new BehaviorSubject(false);
            }
            this.initSubject.next(true);
        }
    };
    ComponentApiController.prototype.destroy = function () {
        this.initSubject.next(false);
        this.api = null;
        this.initSubject.complete();
    };
    ComponentApiController.prototype.callApi = function (cb) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.initSubject.isStopped) {
                reject(new Error('DataGridApiController Error: api already destroyed'));
            }
            _this.initSubject.pipe(filter(Boolean), take(1)).subscribe(function () {
                if (!_this.api) {
                    reject(new Error('DataGridApiController error: api not init'));
                    return;
                }
                try {
                    resolve(cb(_this.api));
                }
                catch (err) {
                    reject(err);
                }
            }, function (err) {
                reject(err);
            });
        });
    };
    return ComponentApiController;
}());
export { ComponentApiController };
//# sourceMappingURL=ComponentApiController.js.map